import { initReactI18next } from 'react-i18next';

import enUSTranslation from '@assets/locales/en_US.json';
import i18n from 'i18next';

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  resources: {
    enUs: {
      translation: enUSTranslation
    }
  },
  lng: 'enUs',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
